import AttachmentIcon from "@mui/icons-material/Attachment";
import CodeIcon from "@mui/icons-material/Code";
import BannerIcon from "@mui/icons-material/Crop169Outlined";
import EmojiObjectsIcon from "@mui/icons-material/EmojiObjects";
import FormatLineSpacingIcon from "@mui/icons-material/FormatLineSpacing";
import HelpIcon from "@mui/icons-material/Help";
import ImageIcon from "@mui/icons-material/Image";
import LinearScaleIcon from "@mui/icons-material/LinearScale";
import LinkIcon from "@mui/icons-material/Link";
import ImageAndButtonIcon from "@mui/icons-material/PhotoSizeSelectLarge";
import ButtonIcon from "@mui/icons-material/SmartButtonOutlined";
import TitleIcon from "@mui/icons-material/Title";
import VideoLibraryIcon from "@mui/icons-material/VideoLibrary";
import ViewHeadlineIcon from "@mui/icons-material/ViewHeadline";
import ViewWeekIcon from "@mui/icons-material/ViewWeek";
import { Box, Card, CardContent, CardHeader, Divider, Grid, Typography } from "@mui/material";
import React from "react";
import { makeStyles } from "tss-react/mui";

import { Sizing, Spacing } from "../types/enum";
import { ElementKind } from "../types/graphql";

import LessonEditPageTemplatesTemplate from "./LessonEditPageTemplatesTemplate";

/**
 * Defaults
 */
const TEMPLATES = [
  { kind: ElementKind.Grid, title: "Grid" },
  { kind: ElementKind.Title, title: "Title" },
  { kind: ElementKind.Paragraph, title: "Text" },
  { kind: ElementKind.Image, title: "Image" },
  { kind: ElementKind.Video, title: "Video" },
  { kind: ElementKind.Links, title: "Links" },
  { kind: ElementKind.Questions, title: "Question" },
  { kind: ElementKind.Ideas, title: "Ideas" },
  { kind: ElementKind.Attachment, title: "Attach" },
  { kind: ElementKind.Spacing, title: "Spacing" },
  { kind: ElementKind.Divider, title: "Divider" },
  { kind: ElementKind.Button, title: "Button" },
  { kind: ElementKind.Banner, title: "Banner" },
  { kind: ElementKind.ImageAndButton, title: "Img&Button" },
  { kind: ElementKind.Embedded, title: "Embedded" },
];

/**
 * Constants
 */
// biome-ignore-start lint/correctness/useJsxKeyInIterable: this is not render function
const ICONS = new Map([
  [ElementKind.Grid, <ViewWeekIcon />],
  [ElementKind.Title, <TitleIcon />],
  [ElementKind.Paragraph, <ViewHeadlineIcon />],
  [ElementKind.Image, <ImageIcon />],
  [ElementKind.Video, <VideoLibraryIcon />],
  [ElementKind.Links, <LinkIcon />],
  [ElementKind.Questions, <HelpIcon />],
  [ElementKind.Ideas, <EmojiObjectsIcon />],
  [ElementKind.Attachment, <AttachmentIcon />],
  [ElementKind.Spacing, <FormatLineSpacingIcon />],
  [ElementKind.Divider, <LinearScaleIcon />],
  [ElementKind.Button, <ButtonIcon />],
  [ElementKind.Banner, <BannerIcon />],
  [ElementKind.ImageAndButton, <ImageAndButtonIcon />],
  [ElementKind.Embedded, <CodeIcon />],
]);
// biome-ignore-end lint/correctness/useJsxKeyInIterable: this is not render function

/**
 * Styles
 */
const useStyles = makeStyles()(() => ({
  root: {
    overflow: "initial",
  },
}));

const LessonEditPageTemplates: React.FC = () => {
  const { classes } = useStyles();

  return (
    <Card className={classes.root}>
      <CardHeader
        title={
          <Box mb={Spacing.xs}>
            <Typography variant="body1">Elements</Typography>
          </Box>
        }
        subheader={
          <Typography variant="body2" color="textSecondary">
            Compose a new section by dragging and dropping elements from the list below
          </Typography>
        }
      />

      <Divider />

      <CardContent>
        <Grid container spacing={Spacing.s}>
          {TEMPLATES.map((template) => (
            <Grid size={{ xs: Sizing.Half }} key={template.kind}>
              <LessonEditPageTemplatesTemplate
                kind={template.kind}
                title={template.title}
                icon={ICONS.get(template.kind)}
              />
            </Grid>
          ))}
        </Grid>
      </CardContent>
    </Card>
  );
};

export default LessonEditPageTemplates;
